import { SeoMapper } from '@search/router/src';

export const bankPledgeMapper = new SeoMapper('bankPledgeMapper', {
    'v-zaloge': 'IN_PLEDGE',
    notInPledge: 'NOT_IN_PLEDGE',
    unknown: 'UNKNOWN'
} as const);
